export default "__VITE_ASSET__6kVkY7a8__"